import { format, isThisWeek, isToday, isYesterday, parseISO } from 'date-fns';
import { enUS as en, es, pt } from 'date-fns/locale';

export const dateLocales = { es, pt, en };
export const relativeDateLocales = {
  es: {
    today: 'Hoy',
    yesterday: 'Ayer',
  },
  pt: {
    today: 'Hoje',
    yesterday: 'Ontem',
  },
  en: {
    today: 'Today',
    yesterday: 'Yesterday',
  },
};

export const formatOptions = {
  date: 'dd MMM, yyyy',
  time: 'HH:mm',
  datetime: 'dd MMM, yyyy HH:mm',
};

export const formatDatascopeDate = (
  datetime: string | Date,
  formatType: keyof typeof formatOptions = 'datetime',
  lang: keyof typeof dateLocales = 'en',
  absoluteFormat = false,
): string => {
  const localeLanguage = dateLocales[lang];

  const date = typeof datetime === 'string' ? parseISO(datetime) : datetime;

  if (absoluteFormat || formatType === 'time')
    return format(date, formatOptions[formatType], { locale: localeLanguage });

  if (isToday(date)) {
    if (formatType === 'date') return relativeDateLocales[lang].today;
    const formattedTime = format(date, formatOptions['time'], { locale: localeLanguage });
    return `${relativeDateLocales[lang].today} ${formattedTime}`;
  }

  if (isYesterday(date)) {
    if (formatType === 'date') return relativeDateLocales[lang].yesterday;
    const formattedTime = format(date, formatOptions['time'], { locale: localeLanguage });
    return `${relativeDateLocales[lang].yesterday} ${formattedTime}`;
  }

  if (isThisWeek(date, { weekStartsOn: 1 })) {
    if (formatType === 'date') return format(date, 'EEEE', { locale: localeLanguage });
    return format(date, 'EEEE HH:mm', { locale: localeLanguage });
  }

  return format(date, formatOptions[formatType], { locale: localeLanguage });
};
